import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import SelectUI from '../../../widgets/input/SelectUI'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import VirtualTransactionsDownloadModalSF from './VirtualTransactionsDownloadModalSF'
import VirtualTransactionsDownload2ModalSF from './VirtualTransactionsDownload2ModalSF'
import './SuTransactionHeader.css'

const SuTransactionHeaderUI = ({ context, account, bankAccountList, bankAccountNumber, onRefreshClick,
  downloadMode, onDownloadClick, onDownloadCancel, searchFilter, onSearchFilterChange,
  year, period, yearList, periodList, onYearChange, onPeriodChange,
}) =>
  <div className='su_txn_hdr'>
    <LRTableActionsUI location='top' className='g_flex_top'
      left={
        <ActionLeftUI
          context={context}
          account={account}
          bankAccountNumber={bankAccountNumber}
          bankAccountList={bankAccountList}
          onRefreshClick={onRefreshClick}
          onDownloadClick={onDownloadClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          yearList={yearList} periodList={periodList}
          year={year} period={period}
          onYearChange={onYearChange} onPeriodChange={onPeriodChange}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <VirtualTransactionsDownload2ModalSF
      context={context} year={year} period={period}
      account={account} bankAccountNumber={bankAccountNumber}
      downloadMode={downloadMode}
      onCancelClick={onDownloadCancel}
      onRefreshClick={onRefreshClick}
    />

  </div>

const ActionLeftUI = ({ account, bankAccountNumber, bankAccountList, onRefreshClick, onDownloadClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
    <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
    {
      bankAccountList.map((bankAccount, i) =>
        <TabLinkUI label={bankAccount.bankAccountNumber} key={i}
          active={bankAccount.bankAccountNumber === bankAccountNumber}
          to={`/su/accounts/${account.accountId}/txns3/${bankAccount.bankAccountNumber}`}
        />
      )
    }
  </div>

const ActionTopRightUI = ({ context, year, period, yearList, periodList, onYearChange, onPeriodChange, searchFilter, onSearchFilterChange }) =>
  <div className='g_text_right'>
    <div className='g_flex_h g_flex_right'>
      <SelectUI selectedKey={'' + year} optionList={yearList} onChange={onYearChange} placeholder='Year' />
      <span className='g_m_left_50' />
      <SelectUI selectedKey={period} optionList={periodList} onChange={onPeriodChange} placeholder='Period' />
      <span className='g_m_left_50' />
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>
  </div >

export default SuTransactionHeaderUI
